export class StorageManager {
    storageKey: string;
    cbs: Function[];
    storageProvider: Storage;

    constructor(storageKey: string, sessionOnly: boolean = false) {
        this.storageKey = storageKey;
        this.cbs = [];
        if (sessionOnly) {
            this.storageProvider = window.sessionStorage;
        } else {
            this.storageProvider = window.localStorage;
        }
    }

    async load() {
        return JSON.parse(this.storageProvider.getItem(this.storageKey) || '{}');
    }
    async getValue(key: string) {
        return (await this.load())[key];
    }

    async update(callback: Function) {
        const data = await this.load();
        const newData = callback(data);
        this.storageProvider.setItem(this.storageKey, JSON.stringify(newData));
        this.cbs.forEach(cb => cb(newData));
    }
    async storeValue(key: string, value: any) {
        this.update((d: any) => ({ ...d, [key]: value }));
    }

    onSave(callback: Function) {
        this.cbs.push(callback);
    }
}